import React from 'react'

const Backend = () => {
    return (
        <div className="skills_content">
            <h3 className="skills_title">Backend Developer</h3>

            <div className="skills_box">
                <div className="skills_group">
                    <div className="skills_data">
                        <i class="bx bx-badge-check"></i>
                        <div>
                            <h3 className="skills_name">Express JS</h3>
                            <span className="skills_level">Basic</span>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div className="skills_data">
                        <div>
                            <h3 className="skills_name">Currently On Learning Phase Of Backend Development</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Backend